import { ampli as ampli_dev } from './ampli.dev+test/index.ts';
import { ampli as ampli_prod } from './ampli.prod/index.ts';

export const ampli = process.env.NODE_ENV === 'development' ? ampli_dev : ampli_prod;

